<div id="list-syllabus" class="content scaffold-list" role="main" *ngIf="syllabusList">
  <h1>Syllabus List</h1>
  <div *ngIf="curriculum" class="alert alert-info text-center">
    {{curriculum.name}}
  </div>

<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
 <tr> <th>id</th>
     <th>Code</th>
     <th>Sub Topics</th>
     <th>Facts</th>
     <th>Description</th>
     <th>Subjects</th>
     <th></th>
     <th></th>
  </tr>
</thead>

<tbody>
  <tr *ngFor="let syllabus of syllabusList">
    <td>{{syllabus.id}}</td>
    <td>{{syllabus.syllabuscode}}</td>
    <td class="text-center"><a [routerLink]="['/admin/syllabus/show',syllabus.id]">{{syllabus.metaData.topicCount}}</a></td>
    <td class="text-center">{{syllabus.metaData.factCount}}</td>
    <td class="text-center">{{syllabus.description}}</td>
    <td class="text-center">{{syllabus.metaData.subjectCount}}</td>
    <td class="text-center">
      <a [routerLink]= "['/admin/syllabus/new',syllabus.id]"><i class="fa fa-plus"> </i>Edit</a>
    </td>
    <td class="text-center">
     <button [disabled]="isTesting" class="btn btn-link" (click)="testSyllabus(syllabus.id)">
       <span *ngIf="isTesting && testSyllabusId==syllabus.id" class="spinner-border spinner-border-sm me-1"></span>
       <i class="fa fa-user-md"></i> Test Syllabus
     </button>
    </td>
    </tr>
</tbody>

</table>

  <fieldset class="buttons text-center">
  <a [routerLink]= "['/home/admin/show']" class="me-2"><i class="fa fa-close"></i> Close</a>
  <a [routerLink]= "['/admin/curriculum/index']"><i class="fa fa-list"></i> Back To Curriculum</a>
  <a [routerLink]= "['/admin/syllabus/new',0]"><i class="fa fa-plus"> </i>Add New Syllabus</a>
  </fieldset>
</div>
<app-spinner *ngIf="loading"> </app-spinner>

